module.exports = __webpack_public_path__ + "img/Kultapossu-II.c2dfa859.png";